export default {
  data() {
    return {
      images: [],
      allImages: [],
      iTotalImages: 0,
      itemsCategories: [],
      sCategoryId: "",
      subcategoryNameEn: "",
      subcategoryNameEs: "",
      texts: "",
      screenWidth: 0,
      subcategory: "",
      bLoading: false,
      bSkeleton: false,
    };
  },
  beforeMount() {
    this.texts = FILE.subcategoryTexts[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  upload() {
    this.$refs.clearUpload.clear();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.$store.commit("setDialogEditSubcategory", {
      active: false,
      arr: [],
    });
    this.subcategoryNameEn = "";
    this.subcategoryNameEs = "";
    this.sCategoryId = "";
    this.allImages = [];
  },
  methods: {
    EditCategory() {
      const changeImage = this.images.length == 1;
      const emptyImage = this.images.length == 0 && this.allImages == "";

      this.bLoading = true;

      const params = {
        oSubcategories: {
          sImageKey: "",
          sCategoryId: this.sCategoryId,
          aTranslations: [
            {
              sName: this.subcategoryNameEn,
              sLang: "en",
            },
            {
              sName: this.subcategoryNameEs,
              sLang: "sp",
            },
          ],
        },
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      if (!emptyImage) {
        DB.put(
          `${URI}/api/v1/${this.selectLanguage}/subcategories/${this.$store.state.arrEditSubcategory.sSubcategoryId}`,
          params,
          config
        )
          .then((response) => {
            if (changeImage) {
              this.sendImage(response);
            } else {
              this.bLoading = false;
              this.close();
              this.mixSuccess(response.data.message);
              this.$store.commit("refresher", true);
            }
          })
          .catch((error) => {
            this.bLoading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
      } else {
        this.bLoading = false;
        this.mixError(this.texts.upload.message);
      }
    },
    sendImage(resp) {
      var form = new FormData();
      form.append("image", this.images[0]);
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.patch(
        `${URI}/api/v1/${this.selectLanguage}/subcategories/storage/${resp.data.results.sSubcategoryId}`,
        form,
        config
      )
        .then((response) => {
          this.bLoading = false;
          this.close();
          this.mixSuccess(response.data.message);
          this.$store.commit("refresher", true);
          this.images = "";
        })
        .catch((err) => {
          this.bLoading = false;
          this.mixError(err.response.data.message);
        });
    },
    getSubcategories() {
      //post credentials and get access token from laravel backend
      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/subcategories/${this.$store.state.arrEditSubcategory.sSubcategoryId}`,
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.sToken,
          },
          params: {
            iPageNumber: 1,
          },
        }
      )
        .then((response) => {
          this.iTotalImages = 1;
          this.allImages = response.data.results.oImages;
          this.subcategoryNameEn = response.data.results.sTranslations.find(
            (res) => {
              return res.sLang == "en";
            }
          ).sName;
          this.subcategoryNameEs = response.data.results.sTranslations.find(
            (res) => {
              return res.sLang == "sp";
            }
          ).sName;
          this.sCategoryId = response.data.results.sCategoryId;
          this.bSkeleton = true;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getCategories() {
      //post credentials and get access token from laravel backend
      DB.get(`${URI}/api/v1/${this.selectLanguage}/categories`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.sToken,
        },
        params: {
          iPageNumber: 1,
        },
      })
        .then((response) => {
          this.itemsCategories = response.data.results;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    close() {
      this.$store.commit("setDialogEditSubcategory", {
        active: false,
        arr: [],
      });
      this.subcategoryNameEn = "";
      this.subcategoryNameEs = "";
      this.sCategoryId = "";
      this.allImages = [];
      this.$refs.clearUpload.clear();
    },
    emitClose() {
      this.$store.commit("setDialogEditSubcategory", {
        active: false,
        arr: [],
      });
      this.subcategoryNameEn = "";
      this.subcategoryNameEs = "";
      this.sCategoryId = "";
      this.allImages = [];
      this.$refs.clearUpload.clear();
    },
    handleResize() {
      if (window.innerWidth >= 960) {
        this.screenWidth = 40;
      } else {
        this.screenWidth = 100;
      }
    },
    setImages(e) {
      this.images = e;
      this.iTotalImages = this.images.length + this.allImages.length;
    },
  },
  computed: {
    selectLanguage() {
      return this.$store.state.language;
    },
    dialogEditSubcategory() {
      return this.$store.state.dialogEditSubcategory;
    },
    validateForm() {
      return (
        this.subcategoryNameEn !== "" &&
        this.subcategoryNameEs !== "" &&
        this.sCategoryId !== "" &&
        this.subcategoryNameEn !== null &&
        this.subcategoryNameEs !== null &&
        this.sCategoryId !== null
      );
    },
  },
  watch: {
    selectLanguage() {
      if (this.selectLanguage) {
        this.texts = FILE.subcategoryTexts[this.selectLanguage];
      }
    },
    dialogEditSubcategory: function() {
      if (this.dialogEditSubcategory) {
        this.$store.commit("setMenuSidebar", { active: false });

        this.texts = FILE.subcategoryTexts[this.selectLanguage];
        this.sCategoryId = this.$store.state.arrEditSubcategory.sCategoryId;
        this.getSubcategories();
        this.getCategories();
      }
    },
  },
};
